import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { LocalstorageService } from "../services/localstorage.service";
import { SurveyService } from "../services/survey.service";
import { Verification } from "../models/verification.model";
import { Employee } from "../models/employee.model";

import * as moment from "moment";
import { AuthDetails } from "../models/auth-details.model";

@Component({
  selector: "app-autoverify",
  template: `<div>
    <mat-spinner color="warn"></mat-spinner>
  </div>`,
})
export class AutoverifyComponent implements OnInit {
  verificationData: Verification = {
    workEmail: "",
    employeeId: "",
    dateOfBirth: "",
    phoneNumber: "",
    personalEmail: "",
  };
  employee: Employee | null = null;

  isCorpId = true;
  appid: string | null = null;
  corpid: string | null = null;
  empid: string | null = null;
  dateofbirth: string | null = null;

  preshifttUrl = "/screening/pre-shift";
  volunteerUrl = "/volunteer";
  exposureUrl = "/covid-exposure";
  eventId: string | null = null;
  locationId: string | null = null;

  constructor(
    @Inject("BASE_URL") public baseUrl: string,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private localstorageService: LocalstorageService,
    private surveyService: SurveyService
  ) {}

  ngOnInit() {
    this.localstorageService.showConfirmDialog = false;

    console.log(this.router.url);
    console.log("autoverify");
    this.appid = this.route.snapshot.paramMap.get("appid");
    this.corpid = this.route.snapshot.paramMap.get("corpid");
    this.empid = this.route.snapshot.paramMap.get("empid");
    this.dateofbirth = this.route.snapshot.paramMap.get("dateofbirth");
    this.eventId = this.route.snapshot.paramMap.get("event");
    this.locationId = this.route.snapshot.paramMap.get("location");

    // If required fields are missing, redirect to manual verify pages
    if (!this.corpid && !this.empid) {
      if (this.router.url.startsWith("/volunteerautoverify")) {
        this.router.navigateByUrl("/verify/volunteer");
      } else {
        this.router.navigateByUrl("/verify/pre-shift");
      }
      return;
    }

    this.verifyEmployee();
  }

  verifyEmployee() {
    const dobFragment = this.dateofbirth ? this.dateofbirth : "";
    let formattedDob = "";

    if (dobFragment) {
      // First, try strict parse as MMDD (common compact fragment)
      const mStrict = moment(dobFragment, "MMDD", true);
      if (mStrict.isValid()) {
        formattedDob = mStrict.year(1900).format("YYYY-MM-DD");
      } else {
        // Fallback: try parsing common date formats permissively
        const mLoose = moment(dobFragment);
        if (mLoose.isValid()) {
          // If parsed year is missing or unrealistic, normalize to 1900 year if input looked like MM-DD or M/D
          const inputLooksLikeMonthDay = /^\s*\d{1,2}[-\/]\d{1,2}\s*$/.test(
            dobFragment
          );
          formattedDob = inputLooksLikeMonthDay
            ? mLoose.year(1900).format("YYYY-MM-DD")
            : mLoose.format("YYYY-MM-DD");
        } else {
          formattedDob = "";
        }
      }
    }

    this.verificationData = {
      workEmail: this.corpid || "",
      employeeId: this.empid || "",
      dateOfBirth: formattedDob,
      phoneNumber: "",
      personalEmail: "",
    };

    console.log(this.verificationData);

    this.surveyService.verifyEmployee(this.verificationData).subscribe(
      (responseData) => {
        this.employee = responseData;
        console.log(this.employee);
        if (this.employee && this.employee.firstName != null) {
          this.setAuthAndRedirect(true);
        } else {
          setTimeout(() => {
            if (this.router.url.startsWith("/volunteerautoverify")) {
              this.router.navigateByUrl("/verify/volunteer");
            } else {
              this.router.navigateByUrl("/verify/pre-shift");
            }
          }, 100);
        }
      },
      (error) => {
        console.error(error);
        // On error, navigate to manual verify
        setTimeout(() => {
          if (this.router.url.startsWith("/volunteerautoverify")) {
            this.router.navigateByUrl("/verify/volunteer");
          } else {
            this.router.navigateByUrl("/verify/pre-shift");
          }
        }, 100);
      }
    );
  }

  setAuthAndRedirect(isAuthenticated: boolean): void {
    const authDetails: AuthDetails = {
      employeeInfo: (this.employee as Employee) || ({} as Employee),
      verificationData: this.verificationData,
      personalInfo: {
        detailId: 0,
        firstName: "",
        lastName: "",
        personalEmail: "",
        cellPhone: "",
        deptnumber: "",
        leadername: "",
        leaderemail: "",
        dateOfBirth: "",
        corpId: "",
        employeeId: "",
      },
      isAuthenticated: isAuthenticated,
      isNewhire: false,
      timestamp: new Date().getTime(),
    };
    this.localstorageService.setAuth(authDetails);
    setTimeout(() => {
      if (this.router.url.startsWith("/volunteerautoverify")) {
        this.router.navigateByUrl(this.volunteerUrl);
      } else if (this.router.url.startsWith("/exposureautoverify")) {
        this.router.navigateByUrl(this.exposureUrl);
      } else {
        if (this.eventId && this.eventId.length > 0) {
          this.router.navigateByUrl("/event/" + this.eventId);
        } else if (this.locationId && this.locationId.length > 0) {
          this.router.navigateByUrl("/location/" + this.locationId);
        } else {
          this.router.navigateByUrl(this.preshifttUrl);
        }
      }
    }, 100);
  }
}
